module.exports = __webpack_public_path__ + "static/img/cont2302.9b1fe13.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont2302.jpg
// module id = sej0
// module chunks = 0